import { render, staticRenderFns } from "./MaterialType.vue?vue&type=template&id=4f521b92"
import script from "./MaterialType.vue?vue&type=script&lang=js"
export * from "./MaterialType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports